import React, { useCallback } from 'react';
import { Skeleton, TextInput } from '@patternfly/react-core';
import ComponentPropTypes from './ComponentPropTypes';

const NumberComponent = ({ model, value, onChange, hasError, isLoading }) => {
  const _onChange = useCallback(_value => {
    onChange(model, _value);
  }, [model, onChange]);

  return (
    <>
      { isLoading && <Skeleton className={'pf-c-form-control'} /> }
      { !isLoading && <TextInput
        type="number"
        id={model.path}
        placeholder={model.placeholder}
        value={value ?? model.placeholder ?? ''}
        validated={hasError ? 'error' : 'default'}
        onChange={(_event, textValue) => _onChange(textValue)}
        onBlur={model?.properties?.onBlur?.()}
      /> }
    </>
  );
};

NumberComponent.propTypes = ComponentPropTypes;

export default React.memo(NumberComponent);
